var _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPushNotificationIcon(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M0 0h24v24H0z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M2.379 9.627c.875.634 2.035 1.44 6.02 4.141.824.562 2.214 1.743 3.601 1.736 1.395.01 2.813-1.196 3.605-1.736l1.705-1.157a2.181 2.181 0 0 0 1.857 1.038c1.077 0 1.969-.782 2.154-1.81H22v5.411c0 .966-.84 1.75-1.875 1.75H3.875C2.84 19 2 18.216 2 17.25V9.798c0-.182.223-.284.379-.171zm13.3-4.629a3.988 3.988 0 0 0-.487 1.922c0 .936-.161 1.474-.435 1.85-.044.06-.09.118-.15.183l-.163.176-.119.14a1.589 1.589 0 0 0-.325.974 1.598 1.598 0 0 0 1.597 1.597l.723-.001-1.453.985c-.656.445-1.96 1.524-2.867 1.51-.906.014-2.21-1.065-2.867-1.51-5.184-3.511-5.578-3.82-6.774-4.692a.868.868 0 0 1-.351-.575L2 7.443V6.75c0-.918.758-1.671 1.721-1.744L3.875 5z",
    fill: "#8F9BB3"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M19.167 12.65c.657 0 1.19-.54 1.19-1.207h-2.38c0 .666.533 1.206 1.19 1.206zm4.006-2.822c-.36-.392-1.032-.98-1.032-2.908 0-1.464-1.013-2.637-2.38-2.924v-.393A.6.6 0 0 0 19.168 3a.6.6 0 0 0-.595.603v.393c-1.367.287-2.38 1.46-2.38 2.924 0 1.928-.672 2.516-1.032 2.908a.593.593 0 0 0-.16.409.6.6 0 0 0 .597.603h7.14a.6.6 0 0 0 .596-.603.593.593 0 0 0-.16-.41z",
    fill: "#8F9BB3"
  }))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPushNotificationIcon);
export default __webpack_public_path__ + "static/media/push-notification-icon.70f63348.svg";
export { ForwardRef as ReactComponent };